import React from "react"
import { Nav } from "./style.css"
import { LaTercera } from "@labcon/copesa-logos"
import LogoLab from "../../assets/logoLab.svg"

const Header = () => {
  return (
    <Nav
      data-sal="slide-down"
      data-sal-delay="2000"
      data-sal-easing="ease"
    >
      <div className="logo">
        <LaTercera schema="common" red="black" />
      </div>
      <div></div>
      <div className="logo">
        <img src={LogoLab} alt="andar juntas" />
      </div>
    </Nav>
  )
}

export default Header
